import { useCallback } from "react"
import { Button, Icon, Tooltip } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { useFavoriteArticlesStore } from "../store"

export function AddNewListButton() {
    const { translateText } = useLocalization()
    const { setCompilationToEdit: setEditFavoriteList } = useFavoriteArticlesStore()

    const handleButtonClick = useCallback(() => {
        setEditFavoriteList({ name: "", type: "add" })
    }, [])

    return (
        <Tooltip title={translateText(13946)}>
            <Button variant="outlined" onClick={handleButtonClick} color={undefined} startIcon={<Icon name="plus" />}>
                {translateText(13948)}
            </Button>
        </Tooltip>
    )
}
